export const siteInfo = {
  name: '尾巴漫画网',
  tagline: '好看的韩国漫画，韩漫在线免费阅读',
  description: '尾巴漫画网专注好看的韩国漫画，提供韩漫在线免费阅读体验。高清无删减内容，下拉式设计让您沉浸其中。每日更新热门韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型。',
  url: 'https://www.weibamanhua.com',
  logo: '尾巴漫画',
  founded: '2020年',
  email: 'contact@weibamanhua.com',
  stats: {
    totalComics: '12,000+',
    dailyReaders: '500,000+',
    monthlyUpdates: '3,000+',
    satisfaction: '98.7%',
  },
};

export const categories = [
  { id: 'love', name: '恋爱', slug: 'love', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫，感受心动瞬间' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '穿越异世界，奇幻冒险韩漫精选' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line', description: '热血激战，动作韩漫燃爆全场' },
  { id: 'suspense', name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line', description: '烧脑推理，悬疑韩漫层层揭秘' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '爆笑日常，搞笑韩漫欢乐不停' },
  { id: 'horror', name: '惊悚', slug: 'horror', icon: 'ri-ghost-line', description: '毛骨悚然，惊悚韩漫挑战胆量' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line', description: '感人至深，剧情韩漫触动心灵' },
  { id: 'school', name: '校园', slug: 'school', icon: 'ri-building-line', description: '青春校园，韩漫里的美好时光' },
];

export const comics = [
  {
    id: 1,
    title: '社内恋爱',
    titleEn: 'Office Romance',
    author: '金智慧',
    artist: '朴美妍',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20beautiful%20couple%20in%20office%20setting%2C%20soft%20warm%20lighting%2C%20manhwa%20art%20style%2C%20clean%20illustration%2C%20modern%20romance%20theme%2C%20emotional%20expression%2C%20pastel%20warm%20tones%2C%20professional%20quality%20digital%20painting&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 9.4,
    views: '1280万',
    status: '连载中',
    chapters: 86,
    updatedAt: '2026-08-04',
    description: '入职第一天就遇到了前男友？而且还是直属上司！李秀雅本以为只是一份普通工作，却不料陷入了甜蜜又危险的办公室恋情。当事业与爱情交织，她该如何抉择？',
    featured: true,
    popular: true,
    tags: ['办公室恋情', '都市', '职场', '甜宠'],
  },
  {
    id: 2,
    title: '异世界重生之魔王降临',
    titleEn: 'Demon King Reborn',
    author: '崔俊浩',
    artist: '李泰民',
    category: 'fantasy',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20powerful%20dark%20warrior%20with%20magical%20aura%2C%20epic%20fantasy%20world%2C%20dramatic%20lighting%2C%20webtoon%20style%20digital%20art%2C%20dark%20armor%2C%20glowing%20runes%2C%20clean%20character%20illustration%20on%20simple%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 9.7,
    views: '2560万',
    status: '连载中',
    chapters: 152,
    updatedAt: '2026-08-05',
    description: '被背叛而死的魔王，竟重生为人类少年！带着前世记忆与力量，他要在全新的世界重新崛起，向那些背叛者复仇。史诗级的奇幻冒险，就此展开！',
    featured: true,
    popular: true,
    tags: ['重生', '奇幻世界', '魔王', '复仇'],
  },
  {
    id: 3,
    title: '暗夜追凶',
    titleEn: 'Night Chase',
    author: '郑宇镇',
    artist: '金敏秀',
    category: 'suspense',
    categoryName: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20thriller%20cover%2C%20detective%20in%20dark%20rainy%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20webtoon%20digital%20painting%20style%2C%20clean%20illustration%2C%20mysterious%20figure%20silhouette%2C%20cold%20blue%20gray%20tones&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 9.5,
    views: '1890万',
    status: '连载中',
    chapters: 94,
    updatedAt: '2026-08-03',
    description: '连环杀手在城市中肆虐，天才侧写师韩在民临危受命。每一个案发现场都是一道谜题，而他必须在下一个受害者出现之前，找出隐藏在暗处的真凶。',
    featured: true,
    popular: true,
    tags: ['推理', '悬疑', '犯罪', '心理'],
  },
  {
    id: 4,
    title: '校园罗曼史',
    titleEn: 'Campus Romance',
    author: '林秀晶',
    artist: '李慧珍',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20cover%2C%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20soft%20spring%20lighting%2C%20manhwa%20art%20style%2C%20clean%20illustration%2C%20youthful%20romantic%20atmosphere%2C%20pastel%20pink%20tones&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 9.2,
    views: '1560万',
    status: '已完结',
    chapters: 120,
    updatedAt: '2026-07-20',
    description: '转学生金泰熙与校草李志勋的偶然相遇，开启了一段甜蜜又青涩的校园恋曲。从互不相识到彼此心动，他们的故事温暖了无数读者的心。',
    featured: false,
    popular: true,
    tags: ['校园', '青春', '甜宠', '治愈'],
  },
  {
    id: 5,
    title: '武神传说',
    titleEn: 'Legend of the Martial God',
    author: '韩东旭',
    artist: '崔正元',
    category: 'action',
    categoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20action%20cover%2C%20powerful%20fighter%20in%20dynamic%20pose%2C%20martial%20arts%20energy%20effects%2C%20dramatic%20composition%2C%20webtoon%20style%20digital%20art%2C%20clean%20illustration%2C%20intense%20battle%20aura%2C%20warm%20action%20tones&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 9.6,
    views: '3120万',
    status: '连载中',
    chapters: 210,
    updatedAt: '2026-08-05',
    description: '被人欺凌的普通高中生，意外觉醒了沉睡千年的武神血脉！从此踏上武道巅峰，以无敌之姿横扫一切强敌。热血沸腾的武学传奇，不容错过！',
    featured: false,
    popular: true,
    tags: ['格斗', '武道', '热血', '逆袭'],
  },
  {
    id: 6,
    title: '鬼医无双',
    titleEn: 'Ghost Doctor Supreme',
    author: '李俊熙',
    artist: '金泰亨',
    category: 'fantasy',
    categoryName: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20medical%20fantasy%20cover%2C%20mysterious%20doctor%20in%20traditional%20hanbok%20with%20magical%20medical%20tools%2C%20ancient%20Korean%20medical%20theme%2C%20soft%20mystical%20glow%2C%20webtoon%20digital%20art%20style%2C%20clean%20illustration%2C%20healing%20aura&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 9.3,
    views: '1450万',
    status: '连载中',
    chapters: 78,
    updatedAt: '2026-08-02',
    description: '现代外科医生穿越到古代朝鲜，凭借现代医术与神秘传承，成为一代鬼医。治病救人，惩恶扬善，他在这个陌生的时代书写属于自己的传奇。',
    featured: false,
    popular: false,
    tags: ['穿越', '医术', '古代', '奇幻'],
  },
  {
    id: 7,
    title: '爆笑家族',
    titleEn: 'Funny Family',
    author: '朴志勋',
    artist: '郑多贤',
    category: 'comedy',
    categoryName: '搞笑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20family%20cover%2C%20funny%20family%20characters%20with%20exaggerated%20expressions%2C%20bright%20colorful%20illustration%2C%20humorous%20manhwa%20art%20style%2C%20clean%20digital%20painting%2C%20warm%20family%20theme%2C%20playful%20atmosphere&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 9.1,
    views: '980万',
    status: '连载中',
    chapters: 65,
    updatedAt: '2026-08-04',
    description: '一家五口的爆笑日常！老爸是搞笑艺人，老妈是暴脾气主妇，三个熊孩子各有各的搞怪技能。温馨又搞笑的家庭喜剧，保证让你笑到肚子疼！',
    featured: false,
    popular: false,
    tags: ['日常', '家庭', '温馨', '搞笑'],
  },
  {
    id: 8,
    title: '镜中世界',
    titleEn: 'Mirror World',
    author: '宋仁秀',
    artist: '尹智慧',
    category: 'horror',
    categoryName: '惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20cover%2C%20eerie%20mirror%20reflection%20with%20dark%20figure%2C%20psychological%20horror%20atmosphere%2C%20dim%20lighting%2C%20webtoon%20digital%20art%20style%2C%20clean%20dark%20illustration%2C%20creepy%20mood%2C%20distorted%20reality%20theme&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 9.0,
    views: '720万',
    status: '已完结',
    chapters: 48,
    updatedAt: '2026-06-15',
    description: '搬进新家的第一天，浴室镜子里映出的不是自己的倒影，而是一个完全陌生的世界。每面镜子都是通往另一个维度的入口，而那里的"自己"正在试图逃出来……',
    featured: false,
    popular: false,
    tags: ['恐怖', '心理', '悬疑', '短篇'],
  },
  {
    id: 9,
    title: '星之继承者',
    titleEn: 'Star Inheritor',
    author: '张瑞元',
    artist: '徐智恩',
    category: 'drama',
    categoryName: '剧情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20cover%2C%20young%20musician%20under%20starry%20night%20sky%2C%20emotional%20dramatic%20scene%2C%20warm%20cinematic%20lighting%2C%20webtoon%20digital%20painting%20style%2C%20clean%20illustration%2C%20touching%20atmosphere%2C%20dreamy%20star%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 9.8,
    views: '2780万',
    status: '连载中',
    chapters: 135,
    updatedAt: '2026-08-05',
    description: '天生拥有绝对音感的天才少女，背负着家族的音乐使命，踏上了追逐梦想的旅程。在星光璀璨的舞台上，她将用音乐打动世界，也将找到真正的自己。',
    featured: true,
    popular: true,
    tags: ['音乐', '梦想', '成长', '感人'],
  },
  {
    id: 10,
    title: '校园生存法则',
    titleEn: 'Campus Survival Rules',
    author: '金秀贤',
    artist: '李敏镐',
    category: 'school',
    categoryName: '校园',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20life%20cover%2C%20group%20of%20students%20in%20modern%20school%20uniform%2C%20dynamic%20school%20scene%2C%20bright%20daylight%2C%20webtoon%20digital%20art%20style%2C%20clean%20illustration%2C%20youthful%20energy%2C%20friendship%20theme&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    views: '1120万',
    status: '连载中',
    chapters: 72,
    updatedAt: '2026-08-03',
    description: '普通高中生张明宇转入了全国最顶尖的精英高中，却发现这里的生存法则远比想象中残酷。学业、友情、竞争，在金字塔顶端的学校里，他要找到属于自己的生存之道。',
    featured: false,
    popular: false,
    tags: ['校园', '竞技', '青春', '友情'],
  },
  {
    id: 11,
    title: '他的谎言',
    titleEn: 'His Lies',
    author: '孙艺珍',
    artist: '金泰亨',
    category: 'love',
    categoryName: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20melodrama%20romance%20cover%2C%20man%20and%20woman%20facing%20each%20other%20in%20rain%2C%20emotional%20intense%20scene%2C%20dramatic%20lighting%2C%20webtoon%20digital%20art%20style%2C%20clean%20illustration%2C%20bittersweet%20atmosphere%2C%20grey%20overcast%20tones&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 9.5,
    views: '2030万',
    status: '连载中',
    chapters: 98,
    updatedAt: '2026-08-05',
    description: '他说他爱我，但每一个字都是谎言。陷入爱情陷阱的崔秀珍，在甜蜜与痛苦之间挣扎。当她终于发现真相，这份感情早已让她无法抽身。虐心又上头的高分韩漫！',
    featured: false,
    popular: true,
    tags: ['虐恋', '都市', '情感', '反转'],
  },
  {
    id: 12,
    title: '剑皇归来',
    titleEn: 'Return of the Sword Emperor',
    author: '车太贤',
    artist: '金宇彬',
    category: 'action',
    categoryName: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20swordsman%20cover%2C%20legendary%20swordsman%20with%20glowing%20sword%2C%20epic%20battle%20pose%2C%20dramatic%20energy%20effects%2C%20webtoon%20digital%20art%20style%2C%20clean%20illustration%2C%20powerful%20warrior%20aura%2C%20ancient%20Korean%20theme&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 9.4,
    views: '1670万',
    status: '连载中',
    chapters: 89,
    updatedAt: '2026-08-04',
    description: '天下第一剑客遭人暗算陨落，百年后灵魂附身于废柴少年。凭借前世记忆与绝世剑法，他誓要重登巅峰，找出当年的幕后黑手！华丽的剑术对决，让人热血沸腾。',
    featured: false,
    popular: false,
    tags: ['武侠', '重生', '剑术', '热血'],
  },
];